// extracted by mini-css-extract-plugin
export var actionIcon = "_tn-0";